import { useState } from "react";
import Select from "react-select";

export const TeamPicker = (props: { advertiser: any; user: any; onSubmit: any; onCancel: any }) => {
    const [tempTeam, setTempTeam] = useState<string>("");

    // if the user belongs to the advertisers ownerTeam, use that ID
    if (!tempTeam) {
        let foundTeam = props.user.teams.filter((team: any) => team.id === props.advertiser.ownerTeam.id);
        if (foundTeam[0]) {
            setTempTeam(foundTeam[0].id);
        } else {
            // if no match was found for ownerTeam, look through all partner teams
            props.advertiser.teams.forEach((advTeam: any) => {
                let found = props.user.teams.filter((team: any) => team.id === advTeam.id);
                if (found[0]) setTempTeam(found[0].id);
            });
        }
    }

    const teamOptions = props.user.teams.map((t: any) => ({ label: t.name, value: t.id }));
    return (
        <div className="team-picker create-popup">
            <h2>Select a team</h2>
            <Select
                options={teamOptions}
                value={tempTeam ? teamOptions.find((t: any) => t.value === tempTeam) : props.advertiser.ownerTeam.id}
                onChange={(e) => {
                    setTempTeam(e.value);
                }}
            />

            <div className="row">
                <input
                    type="button"
                    className="create button"
                    value={`OK`}
                    onClick={() => {
                        props.onSubmit(tempTeam);
                        props.onCancel();
                    }}
                />
                <input
                    type="button"
                    className="cancel button"
                    value="Cancel"
                    onClick={() => {
                        props.onCancel();
                    }}
                />
            </div>
        </div>
    );
};
